<template>
  <primary-btn
  :label="aboutToDelete ? undefined : $t(label)"
  @click="tryToDelete"
  @mouseleave="reset"
  color="red"
  :width="width ? width : '100%'"
  :height="height"
  :loading="loading"
  :disabled="disabled"
  :icon="aboutToDelete ? 'alert-circle-outline' : undefined"/>
</template>
<script>
import PrimaryBtn from '@/components/btns/PrimaryBtn'
export default {
  components: {
    PrimaryBtn
  },
  props: {
    label: String,
    width: Number,
    height: Number,
    disabled: Boolean,
    loading: Boolean,
    action: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      aboutToDelete: false
    }
  },
  methods: {
    async tryToDelete() {
      if (!this.aboutToDelete) {
        this.aboutToDelete = true
        return
      }

      await this.action()
      this.reset()
    },
    reset() {
      this.aboutToDelete = false
    }
  }
}
</script>
<style>
.primary-btn-font-medium.v-btn.v-btn--is-elevated.v-btn--has-bg.theme--light {
  color: #fff;
  font-weight: 400;
  font-size: 0.8rem;
  letter-spacing: 0px;
}
.primary-btn-font-small.v-btn.v-btn--is-elevated.v-btn--has-bg.theme--light {
  color: #fff;
  font-weight: 400;
  font-size: 0.6rem;
  letter-spacing: 0px;
}

.primary-btn-font-medium.v-btn.v-btn--disabled{
  color: #fff;
  font-weight: 400;
  font-size: 0.8rem;
  letter-spacing: 0px;
  font-family: 'Titillium Web', sans-serif;
}
.primary-btn-font-small.v-btn.v-btn--disabled {
  color: #fff;
  font-weight: 400;
  font-size: 0.6rem;
  letter-spacing: 0px;
  font-family: 'Titillium Web', sans-serif;
}
</style>